/**
 * Updates the Apollo cache after adding a saved search.
 *
 * This function modifies the `getSavedSearch` field in the cache by adding
 * the search entry.
 *
 * This function modifies the `getSuggestedSearch` field in the cache by filtering out
 * the search entry with the given `searchId`.
 *
 * @param searchId - The ID of the saved search to remove.
 * @returns A function that takes the Apollo cache object and performs the cache modification.
 */

import { ApolloCache, FetchResult } from "@apollo/client";
import { AddToSavedSearchMutation } from "api";

export const updateCacheAfterSavedSearchAddition =
  (searchId: string) =>
  (
    cache: ApolloCache<any>,
    { data }: Omit<FetchResult<AddToSavedSearchMutation>, "context">
  ) => {
    cache.modify({
      fields: {
        getSavedSearch: (previous) => {
          return [data?.addToSavedSearch, ...previous];
        },
        getSuggestedSearch: (previous, { readField }) =>
          previous?.filter((d) => readField("searchId", d) !== searchId),
      },
    });
  };
